var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63CBFF"
    },
    d: "M512,256c0,17.021-1.661,33.656-4.838,49.748c-3.291,16.697-8.202,32.81-14.566,48.17 c-6.447,15.579-14.399,30.386-23.677,44.231C423.016,466.798,344.795,512,256,512c-41.179,0-80.081-9.718-114.542-27 c-39.852-19.968-73.77-50.04-98.398-86.852c-9.258-13.845-17.209-28.651-23.667-44.231c-6.363-15.36-11.274-31.472-14.566-48.18 C1.661,289.646,0,273.021,0,256C0,114.615,114.615,0,256,0c78.535,0,148.814,35.37,195.772,91.042 c17.993,21.326,32.569,45.652,42.872,72.098C505.846,191.927,512,223.253,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1E4FF"
    },
    d: "M197.485,53.947L197.485,53.947c0-6.636-5.38-12.016-12.016-12.016h-66.873 c-6.636,0-12.016,5.38-12.016,12.016l0,0c0,6.636,5.38,12.016,12.016,12.016h8.36c6.636,0,12.016,5.38,12.016,12.016l0,0 c0,6.636-5.38,12.016-12.016,12.016h-25.6c-6.636,0-12.016,5.38-12.016,12.016l0,0c0,6.636,5.38,12.016,12.016,12.016h66.873 c6.636,0,12.016-5.38,12.016-12.016l0,0c0-6.636,5.38-12.016,12.016-12.016h25.6c6.636,0,12.016-5.38,12.016-12.016l0,0 c0-6.636-5.38-12.016-12.016-12.016h-8.36C202.865,65.963,197.485,60.584,197.485,53.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1E4FF"
    },
    d: "M494.644,163.14h-40.647c-6.635,0-12.016-5.381-12.016-12.016c0-3.323-1.348-6.322-3.521-8.495 c-2.173-2.173-5.183-3.521-8.495-3.521h-25.6c-6.635,0-12.016-5.381-12.016-12.016c0-3.323,1.348-6.322,3.521-8.495 c2.173-2.173,5.183-3.521,8.495-3.521h8.359c6.646,0,12.016-5.381,12.016-12.016s5.381-12.016,12.016-12.016h15.015 C469.765,112.368,484.342,136.694,494.644,163.14z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#228464"
    },
    d: "M512,256c0,2.508-0.031,4.995-0.104,7.481c-0.596,20.532-3.605,40.458-8.756,59.507 c-4.66,1.463-9.613,2.257-14.754,2.257c-15.768,0-29.78-7.471-38.724-19.048c-8.955,11.577-22.967,19.048-38.734,19.048 c-15.768,0-29.79-7.471-38.734-19.048c-8.944,11.577-22.956,19.048-38.734,19.048c-15.768,0-29.78-7.471-38.724-19.048 c-8.955,11.577-22.967,19.048-38.734,19.048s-29.78-7.471-38.734-19.048c-8.944,11.577-22.956,19.048-38.724,19.048 c-15.778,0-29.79-7.471-38.734-19.048c-8.944,11.577-22.967,19.048-38.734,19.048s-29.78-7.471-38.734-19.048 c-8.944,11.577-22.956,19.048-38.724,19.048c-5.141,0-10.094-0.794-14.754-2.257C3.709,303.94,0.7,284.014,0.104,263.481 C0.031,260.995,0,258.508,0,256c0-7.784,0.345-15.485,1.024-23.082c6.76-3.521,14.44-5.517,22.591-5.517 c15.768,0,29.78,7.461,38.724,19.048c8.955-11.588,22.967-19.048,38.734-19.048s29.79,7.461,38.734,19.048 c8.944-11.588,22.956-19.048,38.734-19.048c15.768,0,29.78,7.461,38.724,19.048c8.955-11.588,22.967-19.048,38.734-19.048 s29.78,7.461,38.734,19.048c8.944-11.588,22.956-19.048,38.724-19.048c15.778,0,29.79,7.461,38.734,19.048 c8.944-11.588,22.967-19.048,38.734-19.048c15.767,0,29.78,7.461,38.734,19.048c8.944-11.588,22.956-19.048,38.724-19.048 c8.15,0,15.83,1.996,22.591,5.517C511.655,240.515,512,248.215,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34AD89"
    },
    d: "M508.886,295.988C489.691,418.377,383.781,512,256,512c-116.12,0-214.173-77.312-245.509-183.265 c-1.128-3.793-2.163-7.628-3.103-11.494c-1.724-6.98-3.145-14.064-4.274-21.253H508.886z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M101.073,336.739H62.412c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C106.82,334.167,104.247,336.739,101.073,336.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M77.845,360.249H39.184c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C83.592,357.677,81.019,360.249,77.845,360.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M169.273,410.927h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C175.02,408.354,172.448,410.927,169.273,410.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M214.727,450.112h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C220.473,447.538,217.901,450.112,214.727,450.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M33.938,322.988c0,1.588-0.648,3.03-1.682,4.065c-1.034,1.034-2.476,1.682-4.065,1.682H10.491 c-1.128-3.793-2.163-7.628-3.103-11.494h20.804C31.368,317.241,33.938,319.812,33.938,322.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M484.31,335.694h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C490.057,333.122,487.485,335.694,484.31,335.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M461.322,357.115h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C467.069,354.542,464.497,357.115,461.322,357.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M379.82,385.327h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C385.567,382.754,382.995,385.327,379.82,385.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57CEA7"
    },
    d: "M417.437,435.482h-38.661c-3.174,0-5.747-2.573-5.747-5.747l0,0c0-3.174,2.573-5.747,5.747-5.747 h38.661c3.174,0,5.747,2.573,5.747,5.747l0,0C423.184,432.91,420.611,435.482,417.437,435.482z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M313.783,219.711v285.748C295.215,509.733,275.874,512,256,512c-8.464,0-16.823-0.408-25.078-1.212 c-11.128-1.087-22.047-2.873-32.716-5.339V219.711H313.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M313.783,219.711v114.939c0,0-82.86-12.539-82.86,50.155v125.983 c-11.128-1.087-22.047-2.873-32.716-5.339V219.711H313.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M395.491,198.989c0,64.637-62.454,117.029-139.494,117.029s-139.494-52.391-139.494-117.029 c0-25.401,9.644-48.912,26.039-68.096c3.877-4.535,7.283-9.415,10.167-14.555c2.226-3.929,4.138-8.025,5.726-12.225 c3.145-8.349,5.036-17.168,5.496-26.185c0.073-1.452,0.115-2.915,0.115-4.378c0-34.022,27.575-61.597,61.597-61.597h60.709 c34.022,0,61.597,27.575,61.597,61.597c0,1.463,0.042,2.905,0.115,4.357v0.01c0.69,13.573,4.608,26.687,11.222,38.431 c2.884,5.13,6.29,10.01,10.167,14.545C385.846,150.078,395.491,173.588,395.491,198.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M255.997,316.018c-77.04,0-139.494-52.391-139.494-117.029c0-25.401,9.644-48.912,26.039-68.096 c3.877-4.535,7.283-9.415,10.167-14.555c2.226-3.929,4.138-8.025,5.726-12.225c3.145-8.349,5.036-17.168,5.496-26.185 c0.073-1.452,0.115-2.915,0.115-4.378c0-34.022,27.575-61.597,61.597-61.597h9.383c-23.51,0-42.569,27.575-42.569,61.597 c0,1.463-0.031,2.926-0.073,4.378c-0.324,9.017-1.63,17.836-3.803,26.185c-1.097,4.2-2.414,8.296-3.96,12.225 c-1.985,5.141-4.347,10.021-7.022,14.555c-11.327,19.184-17.993,42.695-17.993,68.096 C159.605,263.627,202.759,316.018,255.997,316.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBA29"
    },
    d: "M298.873,146.753L298.873,146.753c0-27.704-12.859-50.162-28.72-50.162h-28.313 c-15.862,0-28.72,22.458-28.72,50.162l0,0c0,17.176-3.64,33.652-10.028,46.711c-7.641,15.622-12.141,34.768-12.141,55.456 c0,52.64,29.121,95.311,65.045,95.311s65.045-42.673,65.045-95.311c0-20.688-4.499-39.834-12.141-55.456 C302.514,180.405,298.873,163.928,298.873,146.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A322"
    },
    d: "M255.997,344.23c-35.924,0-65.045-42.674-65.045-95.316c0-20.689,4.504-39.832,12.142-55.453 c3.197-6.531,5.705-13.918,7.408-21.817c1.714-7.889,2.623-16.311,2.623-24.889c0-27.711,12.852-50.166,28.714-50.166h6.259 c-8.861,0-16.039,22.455-16.039,50.166c0,8.579-0.502,17.001-1.463,24.889c-0.951,7.899-2.341,15.287-4.127,21.817 c-4.274,15.621-6.781,34.764-6.781,55.453C219.687,301.556,235.945,344.23,255.997,344.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M359.285,116.348c-4.827,7.931-13.552,13.04-23.186,13.04c-14.953,0-27.126-12.173-27.126-27.136 c0-12.236,8.255-23.009,20.072-26.185c2.309-0.627,4.681-0.94,7.053-0.94c4.294,0,8.349,1.003,11.964,2.779v0.01 C348.752,91.491,352.671,104.604,359.285,116.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M203.021,102.253c0,2.382-0.313,4.754-0.93,7.064c-3.187,11.818-13.949,20.072-26.196,20.072 c-9.812,0-18.422-5.235-23.186-13.051c2.226-3.929,4.138-8.025,5.726-12.225c3.145-8.349,5.036-17.168,5.496-26.185 c1.546-0.784,3.187-1.4,4.901-1.86c2.309-0.627,4.681-0.94,7.064-0.94C190.847,75.127,203.021,87.3,203.021,102.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F0F0E"
    },
    d: "M350.796,96.606c0,1.323-0.181,2.611-0.509,3.832c-1.684,6.262-7.393,10.863-14.186,10.863 c-8.116,0-14.694-6.579-14.694-14.694c0-6.794,4.601-12.502,10.863-14.186c1.22-0.328,2.51-0.509,3.832-0.509 C344.218,81.912,350.796,88.489,350.796,96.606z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F0F0E"
    },
    cx: 175.888,
    cy: 96.601,
    r: 14.691
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M350.796,96.606c0,1.323-0.181,2.611-0.509,3.832c-1.729,0.802-3.674,1.255-5.708,1.255 c-7.494,0-13.564-6.07-13.564-13.564c0-2.034,0.452-3.979,1.255-5.708c1.22-0.328,2.51-0.509,3.832-0.509 C344.218,81.912,350.796,88.489,350.796,96.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M190.586,96.606c0,1.323-0.181,2.611-0.509,3.832c-1.729,0.802-3.674,1.255-5.708,1.255 c-7.494,0-13.564-6.07-13.564-13.564c0-2.034,0.452-3.979,1.255-5.708c1.22-0.328,2.51-0.509,3.832-0.509 C184.008,81.912,190.586,88.489,190.586,96.606z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#66664D"
    },
    cx: 226.952,
    cy: 246.962,
    rx: 7.557,
    ry: 14.723
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#66664D"
    },
    cx: 285.048,
    cy: 246.962,
    rx: 7.557,
    ry: 14.723
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoose);
export default __webpack_public_path__ + "static/media/goose.9508ca73a2781d63c01e346f76de8a10.svg";
export { ForwardRef as ReactComponent };